import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormattedText from '../../../components/01_atoms/FormattedText';
import { formattedPrice } from '../../../utils/Gifts/products';
import { getPlaceholderSentenceRegExp } from '../../../utils/string';

import styles from './index.module.scss';

// Session storage key for the order total amount, set on the Thank you page.
export const ORDER_TOTAL_STORAGE_KEY = 'orderTotalAmount';

// Placeholder editors can put into the text to output the order total with
// currency symbol, e.g. "Your order total was {DONATION_AMOUNT}".
const ORDER_TOTAL_PLACEHOLDER = '{DONATION_AMOUNT}';

// Sentence containing the placeholder. Used to hide the sentence if order
// total is unknown.
const ORDER_TOTAL_SENTENCE = getPlaceholderSentenceRegExp(ORDER_TOTAL_PLACEHOLDER);

const BBText = ({ text }) => {
  const [isMounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  let processedText = text;
  if (text.includes(ORDER_TOTAL_PLACEHOLDER)) {
    // Read the order total on every render after hydration, because it can be
    // stored after the block is mounted (e.g. on client side navigation).
    const orderTotal = isMounted ? window.sessionStorage.getItem(ORDER_TOTAL_STORAGE_KEY) : null;
    processedText =
      orderTotal !== null
        ? text.replaceAll(ORDER_TOTAL_PLACEHOLDER, formattedPrice(orderTotal))
        : text.replace(ORDER_TOTAL_SENTENCE, '');
  }

  return (
    <div className={`bb ${styles['bb-text']}`}>
      <FormattedText text={processedText} className="container" />
    </div>
  );
};

BBText.propTypes = {
  text: PropTypes.string.isRequired,
};

export default BBText;
